/**
 * Le durate si leggono come le direbbe una persona: sopra l'ora si passa a ore e minuti,
 * perche "1 h 30 min" si capisce al volo mentre "90 min" va convertito a mente.
 * Unico punto di verita per tutta l'app: elenchi, schede e catalogo.
 */
export function formatMinutes(minutes: number) {
  const total = Math.max(0, Math.round(minutes));
  const hours = Math.floor(total / 60);
  const remainingMinutes = total % 60;
  if (hours === 0) return `${remainingMinutes} min`;
  if (remainingMinutes === 0) return `${hours} h`;
  return `${hours} h ${remainingMinutes} min`;
}

/**
 * Le ore come le scrive il foglio settimanale: `7,5` per sette ore e mezza.
 *
 * Il totale di una giornata sul quaderno del cliente e sempre un numero decimale, perche
 * quello poi si somma e si paga. Nel resto dell'app le durate restano `1 h 30 min`, che si
 * legge meglio: qui serve l'altra forma, e sta accanto alla prima per non nascere in tre
 * copie diverse nelle schermate del registro.
 */
export function formatDecimalHours(minutes: number) {
  const ore = Math.max(0, Math.round(minutes)) / 60;
  return new Intl.NumberFormat("it-IT", { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(ore);
}
